import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AppAuth } from "../util/AppAuth";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { SignInProgress } from "../components/Progress";
import {
  ResourceOperation,
  useApplicationStore,
} from "../context/ApplicationStoreContext";
import { CustomerRepository } from "../DAL/repositories/CustomerRepository";
//define interface Props then set arguments ({test}:Props)

//https://localhost:3000/oauth/callback/?redirect1=cookie&redirect2=plate
//https://liff.line.me/1657081960-VDpmoWzy/?redirect1=cookie
export const OAuthCallbackPage = () => {
  const { route, authStatus, user } = useAuthenticator((context) => [
    context.route,
    context.authStatus,
  ]);
  const { state, dispatch } = useApplicationStore();

  const navigate = useNavigate();

  useEffect(() => {
    console.log(`route:${route}, authStatus:${authStatus}`);
    if (route === "authenticated" && authStatus === "authenticated") {
      CustomerRepository()
        .get(user.username!)
        .then((result) => {
          dispatch({ type: ResourceOperation.GET_CUSTOMER, payload: result });
        });
      navigate("/")
    }
    /*
    if (route === "setup") {      

      AppAuth.initializeLiff()
        .then(() => setTimeout(() => AppAuth.federatedSignIn("LINE"), 1750))
        .catch((err) => {});
        
    } else if (route === "authenticated") {

      const path = localStorage.getItem("redirect_to") || state.redirectTo;
      navigate("/" + path);
  
    }
        */
  }, [route, navigate, authStatus]);

  return <SignInProgress />;
};
